import React from 'react';
import Webform from 'gatsby-drupal-webform';
import WizardPage from '../../webform/element/WizardPage';
import {WizardProgressProvider} from '../../contexts/useWizardProgress';
import {navigate} from 'gatsby';

interface DataContext {
  additionalData: {
    allWebforms: Queries.webform__webform[];
  };
}

export default function SourceRequest({additionalData}: DataContext): React.JSX.Element {
  const endpoint = process.env.DRUPAL_SOURCE + 'react_webform_backend/submit';
  const webformWebform = additionalData.allWebforms.find((item: Queries.webform__webform) => {
    return item.drupal_internal__id === 'source_request';
  });

  resetWizardPageIndex();
  const numberOfPages = webformWebform.elements.filter((element: Queries.webform__webform_elements) => {
    return element.type === 'webform_wizard_page';
  }).length;

  const elem = (
    <WizardProgressProvider numberOfPages={numberOfPages}>
      <section className="vl-region">
        <div className="vl-layout">
          <div className="vl-grid vl-grid--is-stacked">
            <div className="vl-col--12-12 vl-col--12-12--m vl-col--12-12--s">
              <div className="vl-steps vl-steps--has-line">
                <ul className="vl-steps__list">
                  <Webform
                    webform={webformWebform}
                    endpoint={endpoint}
                    customComponents={{
                      webform_wizard_page: WizardPage,
                    }}
                    onSubmit={() => {
                      document.querySelector('.loader-overlay')?.classList.remove('hidden');
                    }}
                    onSuccess={(response) => {
                      document.querySelector('.loader-overlay')?.classList.add('hidden');
                      navigate(response.settings.confirmation_url);
                    }}
                  />
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </WizardProgressProvider>
  );

  return elem;
}

let wizardPageIndex: number = 1;

export function resetWizardPageIndex(): void {
  wizardPageIndex = 1;
}

export function getWizardPageIndex(): number {
  return wizardPageIndex;
}

export function incrementWizardPageIndex(): void {
  wizardPageIndex++;
}